import React from "react";

import { Transaction } from "@common/types/transaction";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { createTransactionDescription } from "./SoftDeletedTransactionToast.lib";

interface SoftDeletedTransactionToastProps {
    transaction: Transaction;
    undo: () => void;
}

export const SoftDeletedTransactionToast: React.FC<
    SoftDeletedTransactionToastProps
> = ({ transaction, undo }) => (
    <HStack justify="between" className="mr-4">
        <div>
            <p>
                Transaction {createTransactionDescription(transaction)} has been
                deleted.
            </p>
        </div>
        <div style={{ flexShrink: 0 }}>
            <Button variant="primary" size="md" onClick={() => undo()}>
                Undo
            </Button>
        </div>
    </HStack>
);
